module.exports = __webpack_public_path__ + "static/media/rfb_testimonial2_bigbear.17101906.jpg";